import { Controller } from "@hotwired/stimulus";

// Marketing cookies (Meta Pixel) only after an explicit yes. Default is no.
const KEY = "pause.consent";

export default class extends Controller {
  static targets = ["banner"];
  static values = { pixelId: String };

  connect() {
    const stored = this.read();
    if (stored === null) this.open();
    if (stored === "accepted") this.loadPixel();
  }

  open() { this.bannerTarget.hidden = false; }

  accept() { this.write("accepted"); this.loadPixel(); this.hide(); }
  reject() { this.write("rejected"); this.hide(); }

  hide() { this.bannerTarget.hidden = true; }

  loadPixel() {
    if (!this.pixelIdValue || window.fbq) return;
    const f = window; const n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
    n.push = n; n.loaded = true; n.version = "2.0"; n.queue = [];
    const t = document.createElement("script"); t.async = true; t.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(t);
    window.fbq("init", this.pixelIdValue);
    window.fbq("track", "PageView");
  }

  read() { try { return localStorage.getItem(KEY); } catch { return "rejected"; } }
  write(value) { try { localStorage.setItem(KEY, value); } catch {} }
}
